import { Box, Button, Modal } from '@leagueplatform/genesis-core';
import React from 'react';
import BackToAcctMgmt from './backToAcctMgmt.component';

export function AccountManagementContainer(props: {
  buttonLabel: string;
  modalTitle: string;
  children: any;
  isOpen: boolean;
  setIsOpen: Function;
  showModal: boolean;
  hideButton: boolean;
  backToAcctMgmtControl: Function;
  submitButton?: any;
  trailingContent?: any;
}) {
  const {
    buttonLabel,
    modalTitle,
    children,
    isOpen,
    setIsOpen,
    showModal,
    hideButton,
    backToAcctMgmtControl,
    submitButton,
    trailingContent,
  } = props;

  return (
    <Modal.Root
      open={showModal || isOpen}
      data-testid="tobacco-modal"
      onOpenChange={() => setIsOpen((previous: any) => !previous)}
    >
      {hideButton ? (
        ''
      ) : (
        <Modal.Trigger>
          {
            // Change this to be the account management clickable item in the Account Management modal
          }
          <Button>{buttonLabel}</Button>
        </Modal.Trigger>
      )}
      <Modal.Content
        showCloseButton={false}
        padding={{
          '@initial': '30px 150px',
          '@laptop': '30px 100px',
          '@tablet': '30px 30px',
          '@mobile': '20px 0',
          '@mobileLandscape': '30px',
        }}
        layout={{ '@initial': 'standard', '@mobile': 'fullscreen' }}
        width={{ '@initial': '65%', '@laptop': '80%', '@mobile': '100vw' }}
        onInteractOutside={(e: any) => e.preventDefault()}
      >
        <Box
          css={{
            height: 'auto',
            padding: '$two $three',
            overflow: 'scroll !important',
            '@mobile': {
              maxWidth: '100vw',
              width: '100%',
              height: '100vh',
            },
          }}
        >
          <BackToAcctMgmt
            customOnClick={() => {
              backToAcctMgmtControl();
            }}
          />
          {children}

          {submitButton && (
            <Box
              css={{
                margin: '$five auto $none auto',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {submitButton}
            </Box>
          )}
          {trailingContent && (
            <Box
              css={{
                marginTop: '$five',
                '@mobile': {
                  marginBottom: '$five',
                  minHeight: '200px',
                  height: 'auto',
                  overflow: 'scroll',
                },
              }}
            >
              {trailingContent}
            </Box>
          )}
        </Box>
        <Modal.Title data-testid="modal-title">{modalTitle}</Modal.Title>
      </Modal.Content>
    </Modal.Root>
  );
}
